export default __webpack_public_path__ + "static/media/Ellipse_1.913d8b69.png";